import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./MainScreen.css";
import ProjectPreview from "../../components/ProjectPreview/ProjectPreview";
import { useLocation, useNavigate } from "react-router-dom";
// import SortIcon from "../../assets/sort.svg";
import { ReactComponent as SortIcon } from "../../assets/sort-icon-color.svg";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import searchIcon from "../../assets/search.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus-icon.svg";
import rootFolderIcon from "../../assets/rootfolder.svg";
import moment from "moment";
import { useTranslation } from "react-i18next";
import AddProjectModal from "../../components/AddProjectModal/AddProjectModal";
import arrowDown from "../../assets/arrowDown.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import { useAuth } from "../../context/AuthContext";
import {
  createOrganization,
  createVersion,
  deleteProject,
  fetchProjectByIdForExplorer,
  fetchProjects,
  fetchSharedProjects,
  forceDeleteProject,
  moveVersion,
  resetProjectsExplorer,
  updateProjectArchiveStatus,
} from "../../store/projectsSlice";
import {
  projectsSelector,
  userSelector,
  currentOrganizationSelector,
  appSelector,
  projectsArchivedSelector,
  currentActiveProjectsAmountSelector,
  organizationsListSelector,
  redirectUrlSelector,
} from "../../store/selectors";
import ProjectExplorer from "../../components/ProjectExplorer/ProjectExplorer";
import DropTarget from "../../components/DropTarget/DropTarget";
import { useMoveFolder } from "../../hooks/useMoveFolder";
import { getUploadSpaceError } from "../../helpers/uploadLimits";
import { OrbitProgress } from "react-loading-indicators";
import {
  fetchNotifications,
  setCurrentUploadingVideosInfo,
  setIsAppLoading,
  setIsMainLoaded,
  setRedirectUrl,
} from "../../store/appSlice";
import EditProjectModal from "../../components/EditProjectModal/EditProjectModal";
import EditProjectPosterModal from "../../components/EditProjectPosterModal/EditProjectPosterModal";
import AddOrganizationModal from "../../components/AddOrganizationModal/AddOrganizationModal";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import {
  fetchCurrentOrgSubscription,
  fetchIsTrialEligible,
  fetchOrganizationsTariffes,
  fetchPublicTariffes,
} from "../../store/tariffesSlice";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import SearchField from "../../components/SearchField/SearchField";
import useIsMobile from "../../hooks/useIsMobile";
import { updateTariffes } from "../../helpers/helpers";
import useOrganizationLimits from "../../hooks/useOrganizationLimits";
import toast from "react-hot-toast";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import CloseButton from "../../components/CloseButton/CloseButton";
import CookieConsent from "react-cookie-consent";
import { createUserSubscription } from "../../store/usersSlice";

function getQueryParam(search, param) {
  const params = new URLSearchParams(search);
  return params.get(param);
}

function MainScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { t, i18n } = useTranslation();
  const { areAllAgreementsAccepted } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const limits = useOrganizationLimits();
  const organizations = useSelector(organizationsListSelector);
  const currentprojectsArray = useSelector(projectsSelector);
  const archivedProjectsArray = useSelector(projectsArchivedSelector);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isArchiveHovered, setIsArchiveHovered] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const projectsArray = showArchived
    ? archivedProjectsArray
    : currentprojectsArray;
  const [isArchiveClearing, setIsArchiveClearing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("newest");
  const [showSortMenu, setShowSortMenu] = useState(false);
  const sortMenuRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const redirectUrl = localStorage.getItem("redirectUrl");
    if (redirectUrl) {
      localStorage.removeItem("redirectUrl");
      navigate(redirectUrl);
    } else {
      document.title = "7cut";
    }
  }, []);

  // Sorting logic (must be before usage)
  const getSortedProjects = (projects) => {
    let arr = [...projects];
    switch (sortOption) {
      case "newest":
        arr.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
        break;
      case "oldest":
        arr.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
        break;
      case "az":
        arr.sort((a, b) => (a.title || "").localeCompare(b.title || "", "ru"));
        break;
      case "za":
        arr.sort((a, b) => (b.title || "").localeCompare(a.title || "", "ru"));
        break;
      default:
        break;
    }
    return arr;
  };

  const filteredProjects = projectsArray.filter((project) => {
    return project.title.toLowerCase().includes(searchQuery.toLowerCase());
  });
  const sortedProjects = getSortedProjects(filteredProjects);
  const user = useSelector(userSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
  const { logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [isOrgPopupOpen, setIsOrgPopupOpen] = useState(false);
  const app = useSelector(appSelector);
  const [currentExtendedProjectId, setCurrentExtendedProjectId] = useState("");
  const userName = user.email;
  const [projectToRename, setProjectToRename] = useState(null);
  const [projectToChangeCover, setProjectToChangeCover] = useState(null);
  const [isAddOrganizationModalOpen, setIsAddOrganizationModalOpen] =
    useState(false);

  useEffect(() => {
    activateTrialIfNeeded();
  }, []);

  const activateTrialIfNeeded = async () => {
    let chosenTrial = getQueryParam(location.search, "trial");
    if (!chosenTrial) return;
    chosenTrial = +chosenTrial;
    const publicTariffesIds = [8, 11, 22];
    const tariffId = publicTariffesIds[chosenTrial - 1];
    const trialRes = await dispatch(
      fetchIsTrialEligible({ organizationId: currentOrganization.id })
    );
    const isTrialEligible = !trialRes.error && trialRes.payload;
    if (!isTrialEligible) return;
    const publicTariffes = await dispatch(fetchPublicTariffes());
    const publicTariffesArray = !publicTariffes.error && publicTariffes.payload;
    const neededTariff = publicTariffesArray.find(
      (tariff) => tariff.id === tariffId
    );
    if (!neededTariff) return;
    const price =
      neededTariff &&
      neededTariff.prices.find((price) => price.periodUnit === "MONTH");
    const trialDays = price.trialDays;

    const trialStartDate = moment().format("YYYY-MM-DD");

    const trialEndDateObject = moment().add(trialDays, "days");
    const trialEndDate = trialEndDateObject.format("YYYY-MM-DD");

    const formData = {
      organizationId: currentOrganization.id,
      subscriptionData: {
        planVersionPriceId: price.id,
      },
      trialStartDate,
      trialEndDate,
      status: "TRIALING",
    };

    dispatch(createUserSubscription(formData)).then((res) => {
      if (!res.error) {
        updateTariffes(user.organizations, dispatch);
        toast.success(
          `Добро пожаловать в 7cut!\nАктивирован бесплатный период тарифа "${neededTariff.name}" до ${trialEndDateObject.format("DD.MM.YYYY")}.\nСоздайте свой первый проект, нажав на кнопку ниже!`,
          { duration: 8000, style: { textAlign: "center", maxWidth: 600 } }
        );
      }
    });
  };

  useEffect(() => {
    dispatch(fetchNotifications());
  }, []);

  useEffect(() => {
    fetchCurrentProjects();
    dispatch(setIsMainLoaded(true));
  }, [showArchived]);

  const fetchCurrentProjects = (withReset = false) => {
    dispatch(
      fetchProjects({
        organizationId: currentOrganization.id,
        isDeleted: showArchived,
      })
    ).then((res) => {
      if (!res.error) {
        dispatch(setIsAppLoading(false));
        if (withReset) {
          dispatch(resetProjectsExplorer());
        }
      }
      setIsArchiveClearing(false);
    });
    dispatch(
      fetchSharedProjects({
        organizationId: currentOrganization.id,
        isDeleted: false,
      })
    );
    updateTariffes(user.organizations, dispatch);
  };

  const handleArchiveProject = (projectId, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmArchive"))) {
      dispatch(
        updateProjectArchiveStatus({ projectId, isArchived: true })
      ).then((res) => {
        toast.success("Проект перемещен в архив");
        fetchCurrentProjects(true);
      });
    }
  };

  const handleDeleteProject = (projectId, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (window.confirm(t("projectScreen.confirmDelete"))) {
      dispatch(forceDeleteProject(projectId)).then((res) => {
        if (!res.error) {
          toast.success("Проект удален");
          fetchCurrentProjects(true);
        }
      });
    }
  };

  const onPressPlus = () => {
    if (!limits) {
      navigate("/pricing");
      return;
    }
    const projectsLimit = limits.find(
      (limit) => limit.attributeCode === "AVAILABLE_PROJECT_COUNT"
    );
    if (
      projectsLimit &&
      projectsLimit.usedValue >= projectsLimit.maxValue &&
      projectsLimit.maxValue !== -1
    ) {
      toast.error(
        "Ваш текущий тариф не позволяет создать большее количество проектов."
      );
      return;
    }
    setIsAddProjectModalOpen(true);
  };

  const handleRenameProject = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    const project = projectsArray.find((p) => p.id === projectId);
    setProjectToRename(project);
  };

  const handleChangeCover = (event, projectId) => {
    event.preventDefault();
    event.stopPropagation();
    const project = projectsArray.find((p) => p.id === projectId);
    setProjectToChangeCover(project);
  };

  // Перетаскивание на главной: видео из дерева слева и файлы с диска
  // бросаются на карточки корневых папок и на папки в дереве.
  // Права проверяет бэкенд: на чужую папку придёт 403.
  const canDrop = !showArchived && !isPageLoading;

  const refreshExplorerFolders = (projectIds) => {
    // fetchProjects здесь не годится: он пересобирает дерево и сворачивает его
    projectIds
      .filter((id) => id != null)
      .forEach((id) =>
        dispatch(fetchProjectByIdForExplorer({ projectId: id }))
      );
  };

  // Перенос папок: подтверждение с изменениями доступа — в useMoveFolder
  const { requestMoveFolder, moveFolderModal } = useMoveFolder({
    onMoved: ({ fromParentId, toParentId }) => {
      if (fromParentId == null || toParentId == null) {
        // Поменялся список корневых папок (карточки на главной) — перечитать
        fetchCurrentProjects(true);
        return;
      }
      refreshExplorerFolders([fromParentId, toParentId]);
    },
  });
  const rootTarget = {
    id: null,
    title: currentOrganization ? currentOrganization.title : "",
  };

  const handleMoveVersion = ({ versionId, fromProjectId }, target) => {
    if (!versionId || String(fromProjectId) === String(target.id)) return;
    dispatch(moveVersion({ versionId, targetProjectId: target.id })).then(
      (res) => {
        if (res.error) {
          const status = res.payload?.status;
          // Нет прав бэкенд отдаёт как 404 (AccessDeniedException → NOT_FOUND)
          toast.error(
            status === 403 || status === 404
              ? "Нет прав на перенос или папка не найдена"
              : "Не удалось переместить видео"
          );
          return;
        }
        toast.success(`Видео перемещено в «${target.title}»`);
        refreshExplorerFolders([fromProjectId, target.id]);
      }
    );
  };

  const uploadFiles = async (files, targetProjectId, targetTitle) => {
    const spaceError = getUploadSpaceError(limits, files);
    if (spaceError) {
      if (!limits) navigate("/pricing");
      else toast.error(spaceError);
      return;
    }

    const started = [];
    for (const file of files) {
      const res = await dispatch(
        createVersion({
          projectId: targetProjectId,
          versionData: { name: file.name, status: "IN_PROGRESS" },
        })
      );
      if (res.error) {
        toast.error(`Не удалось начать загрузку «${file.name}»`);
        continue;
      }
      started.push({
        file,
        data: res.payload,
        isUploaded: false,
        isCompleted: false,
        parentProjectId: targetProjectId,
      });
    }
    if (!started.length) return;

    // Список загрузок берётся из стора в момент записи: попап загрузок
    // мог обновить его, пока создавались версии
    dispatch((dispatch, getState) => {
      const current = getState().app.currentUploadingVideosInfo || [];
      dispatch(setCurrentUploadingVideosInfo([...current, ...started]));
    });
    toast.success(
      started.length === 1
        ? `Видео загружается в «${targetTitle}»`
        : `${started.length} видео загружаются в «${targetTitle}»`
    );
    refreshExplorerFolders([targetProjectId]);
  };

  const renderProject = (projectInfo, index) => {
    if (projectInfo.isUploading) {
      return (
        <ProjectPreview
          index={index}
          projectInfo={projectInfo}
          key={projectInfo.id}
          isUploading={true}
          isArchive={showArchived}
        />
      );
    }

    return (
      <DropTarget
        key={projectInfo.id}
        disabled={!canDrop}
        label={projectInfo.title}
        targetProjectId={projectInfo.id}
        onMoveVersion={(payload) => handleMoveVersion(payload, projectInfo)}
        onMoveFolder={(payload) => requestMoveFolder(payload, projectInfo)}
        onDropFiles={(files) =>
          uploadFiles(files, projectInfo.id, projectInfo.title)
        }
      >
        {({ isOver, dropHandlers }) => (
          <ProjectPreview
            index={index}
            projectInfo={projectInfo}
            canDrag={canDrop}
            parentId={null}
            onClick={() => {
              if (!showArchived) {
                navigate(`/projects/${projectInfo.id}`);
              }
            }}
            onArchive={handleArchiveProject}
            onDelete={handleDeleteProject}
            isArchive={showArchived}
            onRename={(e) => handleRenameProject(e, projectInfo.id)}
            onChangeCover={(e) => handleChangeCover(e, projectInfo.id)}
            dropHandlers={dropHandlers}
            isDropOver={isOver}
          />
        )}
      </DropTarget>
    );
  };
  useEffect(() => {
    if (!showSortMenu) return;
    const handleClickOutside = (event) => {
      if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
        setShowSortMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSortMenu]);

  const showTeamPopup = () => {
    setShowOrganizationPopup(true);
    setShowUserMenu(false);
  };

  const handleOrganizationChange = (organization) => {
    setIsPageLoading(true);
    dispatch({ type: "SET_CURRENT_ORGANIZATION", payload: organization });
    dispatch(
      fetchProjects({
        organizationId: organization.id,
        isDeleted: false,
      })
    ).then((res) => {
      if (!res.error) {
        setShowArchived(false);
        setIsPageLoading(false);
        dispatch(resetProjectsExplorer());
      }
    });
    dispatch(fetchCurrentOrgSubscription({ orgId: organization.id }));
    setShowOrganizationPopup(false);
  };

  const renderDummy = () => {
    return (
      <div className="mainScreen-empty-state">
        <div className="empty-state-message">
          {t("mainScreen.projects.no_projects")}
        </div>
      </div>
    );
  };

  const getNumberedLocalizedString = (amount, key) => {
    let keyLocalized = `${key}_1`;
    if (amount % 10 === 1) {
      keyLocalized = `${key}_1`;
    } else if (amount % 10 > 1 && amount % 10 <= 4) {
      keyLocalized = `${key}_2`;
    } else if (amount % 10 === 0 || amount % 10 > 4) {
      keyLocalized = `${key}_3`;
    }

    return `${showArchived ? "Архив: " : ""}${amount} ${t(keyLocalized)}`;
  };

  const handleAddOrganization = () => {
    setIsAddOrganizationModalOpen(true);
  };

  const handleOrganizationCreated = (data) => {
    dispatch(createOrganization(data)).then((res) => {
      if (!res.error) {
        dispatch({
          type: "SET_CURRENT_ORGANIZATION",
          payload: res.payload,
        });
        dispatch(
          fetchProjects({
            organizationId: res.payload.id,
            isDeleted: showArchived,
          })
        ).then((res) => {
          if (!res.error) {
            dispatch(resetProjectsExplorer());
          }
        });
      }
    });
  };

  const handleClearArchive = async () => {
    if (!showArchived || isArchiveClearing) return;
    if (confirm("Вы действительно хотите очистить архив?")) {
      setIsArchiveClearing(true);
      for (let i = 0; i < sortedProjects.length; i++) {
        if (!showArchived) break;
        const proj = sortedProjects[i];
        await dispatch(forceDeleteProject(proj.id)).then((res) => {});
      }
      toast.success("Архив очищен!");
      fetchCurrentProjects();
    }
  };

  if (app.isAppLoading) {
    return (
      <div className="App">
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <OrbitProgress color="#C1C7D4" />
        </div>
      </div>
    );
  }

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate(0, { replace: true })}
            className={"mainScreen-logoBlock"}
          >
            <img src={AppLogo} style={{ height: "100%" }} />
          </div>
          <div
            style={{
              marginLeft: isMobile ? 0 : 163,
              color: "white",
              fontFamily: "NT Somic",
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            {!isMobile && showArchived ? "Архив" : "Мои проекты"}
          </div>
          <div className="projects-filter"></div>
        </div>
        <div className="header-actions">
          {!isMobile && (
            <>
              <SearchField onValueChanged={(value) => setSearchQuery(value)} />
            </>
          )}
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      <div className="projects-container-content">
        {(!isMobile || isMenuOpen) && (
          <ProjectExplorer
            isMobile={isMobile}
            limits={limits}
            organizations={organizations}
            currentProject={null}
            currentOrganization={currentOrganization}
            isOrgPopupOpen={isOrgPopupOpen}
            onOrganizationSelect={handleOrganizationChange}
            onAddOrganization={handleAddOrganization}
            onOrganizationClick={() => setIsOrgPopupOpen(!isOrgPopupOpen)}
            isPageLoading={isPageLoading}
            showArchived={showArchived}
            canDrop={canDrop}
            onMoveVersion={handleMoveVersion}
            onMoveFolder={requestMoveFolder}
            onDropFilesToFolder={uploadFiles}
          />
        )}
        {/* Вся область карточек — корень пространства: сюда переносятся
            папки из дерева слева */}
        <DropTarget
          disabled={!canDrop}
          isRoot
          label={rootTarget.title}
          onMoveFolder={(payload) => requestMoveFolder(payload, rootTarget)}
        >
          {({ isOver: isFolderOverRoot, dropHandlers: rootDropHandlers }) => (
        <div
          className={`main-projects-container-folders${
            isFolderOverRoot ? " main-projects-container-folders--drop" : ""
          }`}
          {...rootDropHandlers}
        >
          {isFolderOverRoot && (
            <div className="main-projects-drop-overlay">
              Отпустите, чтобы переместить в корень «{rootTarget.title}»
            </div>
          )}
          {!showArchived && !isPageLoading && projectsArray.length === 0 && (
            <div className="projects-container-dummy">
              <div className="projects-container-dummy-title">
                {t("mainScreen.projects.dummy.title")}
                {` ${currentOrganization.title}`}
              </div>
              <span className="projects-container-dummy-subtitle">
                {t("mainScreen.projects.dummy.subtitle")}
              </span>
              <button
                onClick={onPressPlus}
                className="projects-container-dummy-button"
              >
                <PlusIcon
                  className="main-projects-add-btn-plus-icon"
                  style={{
                    transform: "scale(0.9)",
                  }}
                />
                {t("mainScreen.projects.dummy.button")}
              </button>
            </div>
          )}
          {!isPageLoading && (showArchived || projectsArray.length !== 0) && (
            <div className="main-projects-folders-header">
              <span className="main-projects-title">
                {getNumberedLocalizedString(
                  projectsArray.length,
                  "mainScreen.projects.title"
                )}
              </span>
              <button
                className="main-projects-add-btn"
                style={{ display: showArchived ? "none" : "flex" }}
                onClick={onPressPlus}
              >
                <PlusIcon
                  className="main-projects-add-btn-plus-icon"
                  style={{
                    transform: "scale(0.9)",
                  }}
                />
                {!isMobile && t("mainScreen.projects.add")}
              </button>
              {!isMobile && (
                <div className="main-projects-filter-buttons">
                  {!showArchived && (
                    <>
                      <button
                        className={`filter-btn ${
                          !showArchived ? "filter-btn--active" : ""
                        }`}
                        onClick={() => setShowArchived(false)}
                        style={{
                          color: !showArchived
                            ? "#F1F7FF"
                            : isArchiveHovered
                              ? "#C1C7D4"
                              : "#717B8E",
                        }}
                        onMouseEnter={() => setIsArchiveHovered(true)}
                        onMouseLeave={() => setIsArchiveHovered(false)}
                      >
                        {t("mainScreen.projects.filter.all")}
                      </button>

                      <button
                        className={`filter-btn ${
                          showArchived ? "filter-btn--active" : ""
                        }`}
                        onClick={() => setShowArchived(true)}
                        style={{
                          color: showArchived
                            ? "#F1F7FF"
                            : isArchiveHovered
                              ? "#C1C7D4"
                              : "#717B8E",
                        }}
                        onMouseEnter={() => setIsArchiveHovered(true)}
                        onMouseLeave={() => setIsArchiveHovered(false)}
                      >
                        {t("mainScreen.projects.filter.archived")}
                      </button>
                    </>
                  )}
                  {showArchived && (
                    <>
                      <PrimaryButton
                        onClick={handleClearArchive}
                        text={isArchiveClearing ? "Очищаем..." : "Очистить"}
                      />
                    </>
                  )}
                  <div
                    ref={sortMenuRef}
                    className="sort-icon-btn"
                    style={{
                      width: 32,
                      height: 32,
                      marginLeft: 10,
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      justifyContent: "center",
                      position: "relative",
                    }}
                    onClick={() => setShowSortMenu((v) => !v)}
                  >
                    <SortIcon />
                    {/* <img src={SortIcon} style={{ width: 28, height: 28 }} /> */}
                    {showSortMenu && (
                      <div className="main-sort-menu">
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "newest" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("newest");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "newest" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          Сначала новые
                        </div>
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "oldest" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("oldest");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "oldest" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          Сначала старые
                        </div>
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "az" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("az");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "az" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          От А до Я
                        </div>
                        <div
                          className={`main-sort-menu-item${
                            sortOption === "za" ? " selected" : ""
                          }`}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSortOption("za");
                            setShowSortMenu(false);
                          }}
                        >
                          {sortOption === "za" ? (
                            "✓ "
                          ) : (
                            <div style={{ width: 16 }} />
                          )}
                          От Я до А
                        </div>
                      </div>
                    )}
                  </div>
                  {showArchived && (
                    <>
                      <CloseButton
                        onClose={() => setShowArchived(false)}
                        styles={{
                          position: "relative",
                          top: 0,
                          right: 0,
                          marginRight: 3,
                        }}
                      />
                    </>
                  )}
                </div>
              )}
            </div>
          )}
          {!isPageLoading && projectsArray.length !== 0 && (
            <>
              <div
                className={
                  isMobile ? "main-projects-list-mobile" : "main-projects-list"
                }
              >
                {projectsArray.length > 0
                  ? sortedProjects.map((project, index) =>
                      renderProject(project, index)
                    )
                  : renderDummy()}
              </div>
            </>
          )}
          {showArchived && !isPageLoading && projectsArray.length === 0 && (
            <>
              <div className="main-projects-list">
                {projectsArray.length > 0
                  ? sortedProjects.map((project, index) =>
                      renderProject(project, index)
                    )
                  : renderDummy()}
              </div>
            </>
          )}
          {isPageLoading && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OrbitProgress color="#C1C7D4" />
            </div>
          )}
        </div>
          )}
        </DropTarget>
      </div>
      {moveFolderModal}
      {isAddProjectModalOpen && (
        <AddProjectModal
          isOpen={isAddProjectModalOpen}
          onClose={() => setIsAddProjectModalOpen(false)}
        />
      )}
      {projectToRename && (
        <EditProjectModal
          project={projectToRename}
          onRenamed={() => fetchCurrentProjects(true)}
          onClose={() => setProjectToRename(null)}
        />
      )}
      {projectToChangeCover && (
        <EditProjectPosterModal
          project={projectToChangeCover}
          onPosterUpdated={() => fetchCurrentProjects(true)}
          onClose={() => setProjectToChangeCover(null)}
        />
      )}
      {showOrganizationPopup && (
        <div className="modal-overlay">
          <div className="modal-content organization-popup">
            <h2>{t("mainScreen.organization.title")}</h2>
            <div className="organization-list">
              {organizations.map((org) => (
                <div key={org.id} className="organization-item">
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="organization"
                      checked={currentOrganization.id === org.id}
                      onChange={() => handleOrganizationChange(org)}
                    />
                    <span title={org.title || org.name || org.email}>
                      {(org.title || org.name || org.email).length > 40
                        ? (org.title || org.name || org.email).slice(0, 40) +
                          "..."
                        : org.title || org.name || org.email}
                    </span>
                  </label>
                </div>
              ))}
            </div>
            <button
              className="org-close-button"
              onClick={() => setShowOrganizationPopup(false)}
            >
              {t("common.close")}
            </button>
          </div>
        </div>
      )}
      {isAddOrganizationModalOpen && (
        <AddOrganizationModal
          isOpen={isAddOrganizationModalOpen}
          onClose={() => setIsAddOrganizationModalOpen(false)}
          onOrganizationCreated={handleOrganizationCreated}
        />
      )}

      <div
        style={{
          position: "absolute",
          padding: "10px 8px",
          backgroundColor: "#3496FF",
          borderRadius: 8,
          bottom: 35,
          right: 35,
          color: "white",
          fontWeight: 500,
          fontSize: 14,
          cursor: "pointer",
        }}
        onClick={() => {
          navigate("/support");
        }}
      >
        Оставить отзыв
      </div>
    </div>
  );
}

export default MainScreen;
